<template>
  <div class="topbar">
    <!-- Language Dropdown -->
    <div class="topbar-item">
      <LanguageDropdown />
    </div>

    <!-- User Dropdown -->
    <div class="topbar-item user-dropdown" ref="userDropdown">
      <div class="btn-user-nav" @click="toggleDropdown">
        <span class="user-nav-text">{{ username }}</span>
        <img src="/assets/images/user.jpg" class="user-nav-image ml-2" />
      </div>

      <div v-if="isOpen" class="nav-user-dropdown">
        <memlist-button variant="outline-success" @click="onMyProfile">
          {{ $t('ACCOUNT.MY_PROFILE') }}
        </memlist-button>
        <hr class="w-100" />
        <memlist-button variant="outline-success" @click="onLogOut">
          {{ $t('ACCOUNT.LOGOUT') }}
        </memlist-button>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageDropdown from '@/view/layout/header/LanguageDropdown.vue';
import i18nService from '@/core/services/i18n.service.js';
import { mapGetters } from 'vuex';
import { MEMBER_LOGOUT } from '@/core/services/store/member.auth.module';

export default {
  name: 'MemberTopbar',
  components: { LanguageDropdown },
  data() {
    return {
      isOpen: false,
      languageFlag: '',
      languages: i18nService.languages
    };
  },
  computed: {
    ...mapGetters(['currentMember', 'memberCompany', 'mlogin_link']),
    username() {
      return this.$t('ACCOUNT.MY_ACCOUNT');
    }
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    this.onLanguageChanged();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    onClickOutside(e) {
      if (!this.$refs.userDropdown.contains(e.target)) {
        this.isOpen = false;
      }
    },
    onLanguageChanged() {
      const active = i18nService.getActiveLanguage();
      const lang = this.languages.find(val => val.lang === active);
      this.languageFlag = lang ? lang.flag : '';
    },
    onMyProfile() {
      this.$router.push({ name: 'profile' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    onLogOut() {
      const company_id = this.currentMember?.company_id;

      if (this.currentMember?.company_id) {
        // optional logging if needed
      }
      this.$store.dispatch(MEMBER_LOGOUT);
      if (this.mlogin_link) {
        this.$router.push(this.mlogin_link);
      }
      else {
        this.$router.push(`/login/${company_id}`);
      }
      
    }
  }
};
</script>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  gap: 16px;
}

.topbar-item {
  position: relative;
}

.btn-user-nav {
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-nav-text {
  font-size: 1.1rem;
  color: #6c7293;
}

.user-nav-image {
  max-height: 38px;
  max-width: 38px;
  border-radius: 50%;
}

.nav-user-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 8px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 250px;
  z-index: 1000;
  padding: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.nav-user-dropdown hr {
  margin: 10px 0;
}
</style>
